import type { Subnav } from 'cadenza/header/subnav';

/** Returns the default map in Cadenza Classic. */
export function getDefaultMap () {
  const mapElement = document.getElementById('map');
  // @ts-ignore – `map` is added via `Object.assign` (see map.js)
  return mapElement && mapElement.map;
}

export function getSubnav () {
  return document.querySelector<Subnav>('d-subnav');
}
